<template>
  <b-modal
    v-model="showModal"
    title="Calculators"
    size="md"
    hide-footer
    @hidden="clearAllCalculators"
  >
    <div class="calculator-container">
      <!-- Tab Buttons -->
      <div class="tab-buttons mb-1">
        <button
          :class="['tab-btn', { active: viewType === 'mrp' }]"
          @click="viewType = 'mrp'"
        >
          Rev. MRP
        </button>
        <button
          :class="['tab-btn', { active: viewType === 'ptr' }]"
          @click="viewType = 'ptr'"
        >
          PTR & PTS
        </button>
        <button
          :class="['tab-btn', { active: viewType === 'lot' }]"
          @click="viewType = 'lot'"
        >
          LOT/RATE
        </button>
      </div>

      <!-- Calculator Components -->
      <MRPCalculator v-if="viewType === 'mrp'" />
      <PTRAndPTSCalculator v-if="viewType === 'ptr'" />
      <LOTCalculator v-if="viewType === 'lot'" />
    </div>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import LOTCalculator from './LOTCalculator.vue'
import MRPCalculator from './MRPCalculator.vue'
import PTRAndPTSCalculator from './PTRAndPTSCalculator.vue'

export default {
  components: {
    BModal,
    LOTCalculator,
    MRPCalculator,
    PTRAndPTSCalculator,
  },
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      viewType: 'mrp',
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      },
    },
  },
  methods: {
    clearAllCalculators() {
      // Reset to default tab when modal is closed
      this.viewType = 'mrp'
    },
  },
}
</script>

<style scoped>
.calculator-container {
  padding: 8px;
}

.tab-buttons {
  display: flex;
  gap: 0;
  border: 1px solid #007bff;
  border-radius: 8px;
  overflow: hidden;
}

.tab-btn {
  flex: 1;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  background-color: #fff;
  color: #007bff;
  cursor: pointer;
  transition: all 0.2s;
  border-right: 1px solid #007bff;
}

.tab-btn:last-child {
  border-right: none;
}

.tab-btn:hover {
  background-color: #e7f3ff;
}

.tab-btn.active {
  background-color: #007bff;
  color: #fff;
}

.tab-btn:focus {
  outline: none;
}
</style>

<style>
/* Global styles for positioning modal at bottom right */
.calculator-modal-bottom-right .modal-dialog {
  position: fixed;
  bottom: 20px;
  right: 20px;
  margin: 0;
  width: 350px;
  max-width: 350px;
}

.calculator-modal-bottom-right .modal-content {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
